import {createSlice, PayloadAction} from "@reduxjs/toolkit";


interface PreservedTestsState {
    success:boolean,
    message:string,
}

const preservedTestsSlice = createSlice({
    name: "preservedTests",
    initialState: {
        success:false,
        message:""
    } as PreservedTestsState,
    reducers: {
        preservedTest: (state, action:PayloadAction<PreservedTestsState>) => {
            console.log(action.payload, 'actionaction')
            state.success = action.payload.success;
            state.message = action.payload.message;
        },
        resetPreservedTest: (state) => {
            state.success = false;
            state.message = "";
        },
    },
});

export const { preservedTest,resetPreservedTest } = preservedTestsSlice.actions;
export const preservedTestsReducer = preservedTestsSlice.reducer;
export const preservedTestAction = preservedTestsSlice.actions.preservedTest;
